import { render, staticRenderFns } from "./FormAcquisto.vue?vue&type=template&id=5d131a6e"
import script from "./FormAcquisto.vue?vue&type=script&lang=js"
export * from "./FormAcquisto.vue?vue&type=script&lang=js"
import style0 from "./FormAcquisto.vue?vue&type=style&index=0&id=5d131a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports